module.exports = __webpack_public_path__ + "media/images/admin/pattern-a7e8807973c786ebcdbedfb72e777696.png";